import { useState } from 'react';
import { useWalletStore } from '../store/useWalletStore';
import { useWebAuthn } from '../hooks/useWebAuthn';

export function DeviceManager() {
  const { devices, addDevice } = useWalletStore();
  const [label, setLabel] = useState('Backup Device');
  const [busy, setBusy] = useState(false);
  const { buildCreationOptions, createCredential } = useWebAuthn();

  async function registerBackup() {
    setBusy(true);
    try {
      const challenge = btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32)))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
      const opts = buildCreationOptions({ challenge, rpId: location.hostname, userId: 'anon', userName: 'anonymous' });
      const cred = await createCredential(opts);
      addDevice(label, cred.id);
    } catch (e) {
      alert((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="rounded border border-slate-800 p-4">
      <h3 className="font-medium">Devices</h3>
      <ul className="mt-2 space-y-2">
        {devices.map(d => (
          <li key={d.id} className="flex items-center justify-between rounded border border-slate-800 p-2">
            <div>
              <div className="text-sm">{d.label}</div>
              <div className="text-xs text-slate-400">{new Date(d.createdAt).toLocaleString()}</div>
            </div>
            <span className="text-xs text-slate-400">{d.id.slice(0,6)}…</span>
          </li>
        ))}
        {devices.length === 0 && <li className="text-slate-400">No devices yet.</li>}
      </ul>
      <div className="mt-3 grid gap-2 sm:grid-cols-[1fr_auto]">
        <input value={label} onChange={e=>setLabel(e.target.value)} className="rounded border border-slate-700 bg-slate-900 px-3 py-2" />
        <button onClick={registerBackup} disabled={busy} className="rounded bg-teal-600 px-3 py-2 hover:bg-teal-500 disabled:opacity-50">{busy ? 'Registering…' : 'Add Backup Device'}</button>
      </div>
      <p className="mt-2 text-xs text-slate-400">For high-value transactions (&gt;100 USDT), approvals from 2 devices are required.</p>
    </section>
  );
}


